module.exports = __webpack_public_path__ + "img/plus.071640f9.svg";